import React from 'react';
import { observer } from 'mobx-react-lite';
import { Cron, CronError } from '@levashovn/react-js-cron-mui5';

export const CronComponent = observer(
    ({
        value,
        setValue,
        setError,
    }: {
        value: string;
        setValue: (e: string) => void;
        setError: (e: CronError) => void;
    }) => {
        return (
            <Cron
                className='sheduler-wrapper'
                disabled={false}
                value={value}
                setValue={setValue}
                onError={setError}
                clearButton={false}
            />
        );
    }
);
